import { css } from '@emotion/react';
import { Z_INDEX } from '../../constants/zIndex';

export const menuBlockStyles = {
    block: css({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: '12px',
        alignItems: 'center',
        position: 'fixed',
        top: '15px',
        right: '15px',
        zIndex: Z_INDEX.MENU_BLOCK,
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        padding: '8px 12px',
        width: 'fit-content',
    }),
    blockWithLeft: css({
        '@media (min-width: 600px)': {
            left: 'unset',
        },
    }),
    charge: css({
        backgroundColor: '#ffffff',
        borderTopLeftRadius: '8px',
        borderBottomLeftRadius: '8px',
        padding: '0 12px 0 0',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRight: '2px solid #EDEDED',

        '@media (min-width: 600px)': {
            padding: '8px',
        },
    }),
    menuBlockWithStation: css({
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        padding: '8px 0',
        gap: '12px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',

        '@media (min-width: 600px)': {
            padding: '8px 13px',
        },
    }),
    blockWithStation: css({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'fixed',
        top: '0',
        right: '0',
        zIndex: Z_INDEX.MENU_BLOCK,
        width: '100%',
        background: '#fff',
        padding: '8px 16px',

        '@media (min-width: 600px)': {
            justifyContent: 'flex-end',
            padding: '15px',
            background: 'unset',
            flexDirection: 'column-reverse',
            gap: '10px',
            alignItems: 'flex-end',
        },

        '@media (min-width: 992px)': {
            flexDirection: 'row',
            alignItems: 'center',
        },
    }),
    stationInfo: css({
        color: '#000000',
        fontSize: '15px',
        fontWeight: '700',

        '@media (min-width: 600px)': {
            color: '#ffffff',
        },
    }),
    chargeTitle: css({
        fontSize: '12px',
        fontWeight: '700',
        color: '#000000',
        marginRight: '33px',
        display: 'flex',
        alignItems: 'center',
    }),
    titleBlock: css({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    }),
    chargeTitleText: css({
        marginLeft: '8px',
    }),
    chargeValuesBlock: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        marginRight: '4px',
    }),
    chargeValuesLine: css({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        fontSize: '10px',
        lineHeight: '10px',
        fontWeight: '500',
        color: '#000000',
    }),
    chargeValue: css({
        fontWeight: '700',
        marginRight: '2px',
    }),
};
